// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assignment-type__radio-label input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -10;\n  opacity: 0;\n}\n.assignment-type__phone-multiple .link-label {\n  padding-right: 5px;\n  color: var(--color-primary);\n  color: var(--color-secondary);\n  text-transform: uppercase;\n}\n.assignment-type__phone-multiple .link-text {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
